import React, {useState} from 'react';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import DotsLoading from '../../../../components/dotsLoading';
import HeaderInfo from './headerInfo';

import classNames from 'classnames';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {useSafeNavigateBack} from '../../myStore/pages/myStoreAdvertisement/useSafeNavigate';

interface ChatHeaderProps {
  isLoading: boolean;
  name: string;
  isReportOpen: boolean;
  chatId?: string;
  imgUrl?: string;
  isDeleteOpen: boolean;
  supplierGuid: string;
  setIsReportOpen: (isReportOpen: boolean) => void;
  setIsDeleteOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const ChatHeader = ({
  name,
  chatId,
  imgUrl,
  isReportOpen,
  isLoading,
  isDeleteOpen,
  supplierGuid,
  setIsReportOpen,
  setIsDeleteOpen,
}: ChatHeaderProps) => {
  const safeNavigateBack = useSafeNavigateBack('/my-chats');
  const [isOpenBottomSheet, setisOpenBottomSheet] = useState(false);
  const actionList = [
    {
      icon: 'icon-nameDelete',
      action: () => {
        setIsDeleteOpen(!isDeleteOpen);
      },
      title: 'حذف ',
    },
    {
      icon: 'icon-namereport-2',
      action: () => {
        setIsReportOpen(!isReportOpen);
      },
      title: 'گزارش تخلف',
    },
  ];
  return (
    <div className=" pl-6 pr-2 top-0 w-full bg-white flex justify-between items-center min-h-[56px] shadow-[0_4px_5px_rgba(171,190,209,0.3)]">
      {isLoading ? (
        <div className="flex justify-center w-full pt-2">
          <DotsLoading />
        </div>
      ) : (
        <>
          <div className="flex items-center justify-between w-full gap-3">
            <HeaderInfo
              name={name}
              imgUrl={imgUrl}
              prevRoute={safeNavigateBack}
              supplierGuid={supplierGuid}
            />
            {chatId && (
              <button
                className="flex items-center"
                onClick={() => setisOpenBottomSheet(prev => !prev)}
              >
                <SpanIcon className="icon-nameInfo-menu-1 text-[19px] text-gray-700" />
              </button>
            )}
          </div>
        </>
      )}
      <BottomSheet
        onDismiss={() => setisOpenBottomSheet(false)}
        open={isOpenBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
      >
        <div className="flex flex-col w-full gap-4 px-3 py-4 text-gray-900 text-md font-Medium">
          {actionList.map((item, index) => (
            <div
              className="flex items-center gap-2 w-100"
              key={index}
              onClick={() => {
                item.action();
                setisOpenBottomSheet(false);
              }}
            >
              <SpanIcon
                className={classNames(' text-xl text-red-600', item.icon)}
              />
              <span>{item.title}</span>
            </div>
          ))}
        </div>
      </BottomSheet>
    </div>
  );
};

export default ChatHeader;
ChatHeader.defaultProps = {
  isLoading: false,
};
